"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = ['file', 'mobileText', 'mobileThumbnail'];
exports.fields = fields;
var initialValues = {
  file: null,
  mobileText: '<p><a href="[url]" target="_blank" rel="noopener noreferrer">Tap to open: [name]</a></p>',
  mobileThumbnail: null
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-book"
});
exports.icon = icon;
var validate = function validate(values) {
  return {};
};
exports.validate = validate;
var getMetricsPrefix = function getMetricsPrefix() {
  return 'pd';
};
exports.getMetricsPrefix = getMetricsPrefix;
var getDataDefinitions = function getDataDefinitions(id, settings) {
  return {};
};
exports.getDataDefinitions = getDataDefinitions;
var getMetrics = function getMetrics(id, settings, answer) {
  return {};
};
exports.getMetrics = getMetrics;